import { useEvents } from '@api/useEvents'
import { Form, Select } from 'antd'
import type React from 'react'
import { useEffect } from 'react'
import moment from 'moment'

const { Option } = Select

interface AssociateExistingEventProps {
  selectedEventId: string | null
  setEventId: (eventId: string | null) => void
}

const AssociateExistingEvent: React.FC<AssociateExistingEventProps> = ({ selectedEventId, setEventId }) => {
  const { metadataQuery } = useEvents()
  const { data: metadata, isPending, isError } = metadataQuery

  useEffect(() => {
    if (!selectedEventId && metadata?.events && metadata.events.length > 0) {
      setEventId(metadata.events[0].id)
    }
  }, [metadata, selectedEventId, setEventId])

  if (isPending) return <p>Loading...</p>
  if (isError) return <p>Error loading events...</p>

  return (
    <Form layout='vertical'>
      <Form.Item label='Event'>
        <Select placeholder='Select Event' value={selectedEventId ?? undefined} onChange={(value) => setEventId(value)}>
          {metadata?.events.map((event) => (
            <Option key={event._id} value={event._id}>
              {event.name} (Last Used: {moment(event.last_used).format('DD/MM/YYYY')})
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  )
}

export default AssociateExistingEvent
